import React from 'react';
import { BlockNode } from './BlockNode';
import { Chevron } from './Chevron';
import {
	AbsoluteCenterWrapper,
	BlockLinkLine,
	ElementWrapper,
	StyledBlockLinkContainer,
} from './styled';
import {
	nodeDiameter,
	nodeRadius,
} from '@dealstack/frontend/shared/lib/BlockTable/BlockLink/innerBorderWidth.tsx';

interface Props {
	hasArrowLeft?: boolean;
	hasArrowRight?: boolean;
	hasNodeLeft?: boolean;
	hasNodeRight?: boolean;
	children: React.ReactNode;
	hidden?: boolean;
	isMiddle?: boolean;
	sourceColor: string;
	destinationColor: string;
	lineColor: string;
	label?: string;
	nodeLeftContextMenuHeader: string;
	nodeRightContextMenuHeader: string;
	nodeLeftContextMenuItems?: string[];
	nodeRightContextMenuItems?: string[];
}

/**
 * Arrow/Node component that resizes to width of parent, with configurable direction and color.
 * @param color - Color of the chevron + line
 * @param position - Direction of the blockLink
 * @param showChevron - Whether to show the chevron or not
 * @constructor
 */
export const BlockLink = ({
	hasArrowLeft,
	hasArrowRight,
	hasNodeLeft,
	hasNodeRight,
	children,
	hidden,
	sourceColor,
	destinationColor,
	lineColor,
	label,
	isMiddle,
	nodeLeftContextMenuHeader,
	nodeRightContextMenuHeader,
	nodeLeftContextMenuItems,
	nodeRightContextMenuItems,
}: Props) => {
	return (
		<StyledBlockLinkContainer
			style={{
				visibility: hidden ? 'hidden' : 'visible',
			}}
		>
			<ElementWrapper
				style={{
					marginLeft: -nodeRadius,
				}}
			>
				{hasNodeLeft && (
					<BlockNode
						color={sourceColor}
						contextMenuHeader={nodeLeftContextMenuHeader}
						contextMenuItems={nodeLeftContextMenuItems}
					/>
				)}
				{hasArrowLeft && (
					<Chevron
						color={lineColor}
						position="left"
						additionalMarginLeft={isMiddle ? nodeDiameter : 0}
					/>
				)}
			</ElementWrapper>

			<BlockLinkLine color={lineColor} />
			<AbsoluteCenterWrapper>{children}</AbsoluteCenterWrapper>

			<ElementWrapper style={{ marginRight: -nodeRadius }}>
				{hasArrowRight && <Chevron color={lineColor} position="right" />}
				{hasNodeRight && (
					<BlockNode
						label={label}
						color={destinationColor}
						contextMenuHeader={nodeRightContextMenuHeader}
						contextMenuItems={nodeRightContextMenuItems}
					/>
				)}
			</ElementWrapper>
		</StyledBlockLinkContainer>
	);
};
